import React from 'react';
export function RobotsPage() {
  const robotsTxt = `User-agent: *
Allow: /

Sitemap: https://crmkraft.de/sitemap.xml

Crawl-delay: 1`;
  return <pre style={{
    margin: 0,
    padding: 0,
    fontFamily: 'monospace',
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  }} data-id="element-693">
      {robotsTxt}
    </pre>;
}